/* eslint-disable max-len */
import subModuleKeys from '@/modules/constants/subModuleKeys';

const MerchandiseConnectionsEdit = () => import(/* webpackChunkName: "merchandiseconnectionsedit" */ '@/components/modules/ticketsystem/sales/merchandise/connections-edit/MerchandiseConnectionsEdit.vue');
const SalesStatisticsModule = () => import(/* webpackChunkName: "salestatistics" */ '@/components/modules/statistics/SalesStatisticsModule.vue');
const ListEventsModule = () => import(/* webpackChunkName: "listevents" */ '@/components/modules/ticketsystem/listevents/ListEventsModule.vue');
const SalesLinksModule = () => import(/* webpackChunkName: "saleslinks" */ '@/components/modules/ticketsystem/saleslinks/SalesLinksModule.vue');
const ArenaSeatingModule = () => import(/* webpackChunkName: "arenaseating" */ '@/components/modules/ticketsystem/seating/ArenaSeatingModule.vue');
const ComboSalesModule = () => import(/* webpackChunkName: "combosales" */ '@/components/modules/ticketsystem/sales/ComboSalesModule.vue');
const MerchandiseModule = () => import(/* webpackChunkName: "merchandise" */ '@/components/modules/ticketsystem/sales/merchandise/MerchandiseModule.vue');
const MerchandiseMainMenu = () => import(/* webpackChunkName: "merchandisemainmenu" */ '@/components/modules/ticketsystem/sales/merchandise/MerchandiseMainMenu');
const MerchandiseList = () => import(/* webpackChunkName: "merchandiselist" */ '@/components/modules/ticketsystem/sales/merchandise/merchandise-list/MerchandiseList.vue');
const MerchandiseConnections = () => import(/* webpackChunkName: "merchandiseconnections" */ '@/components/modules/ticketsystem/sales/merchandise/connections/MerchandiseConnections.vue');
const MerchandiseEdit = () => import(/* webpackChunkName: "merchandiseedit" */ '@/components/modules/ticketsystem/sales/merchandise/merchandise-edit/MerchandiseEdit');
const ManageEvent = () => import(/* webpackChunkName: "manageevent" */ '@/components/modules/ticketsystem/manageevent/ManageEvent.vue');
const ManageEventBaseInfo = () => import(/* webpackChunkName: "manageeventbaseinfo" */ '@/components/modules/ticketsystem/manageevent/base-info/ManageEventBaseInfo.vue');
const ManageEventBasicInfo = () => import(/* webpackChunkName: "manageeventbasicinfo" */ '@/components/modules/ticketsystem/manageevent/base-info/basic-info/ManageEventBasicInfo.vue');
const ManageEventBranding = () => import(/* webpackChunkName: "manageeventbranding" */ '@/components/modules/ticketsystem/manageevent/base-info/branding/ManageEventBranding.vue');
const ManageEventPurchaseSettings = () => import(/* webpackChunkName: "manageeventpurchasesettings" */ '@/components/modules/ticketsystem/manageevent/base-info/purchase-settings/ManageEventSalesOptions.vue');
const ManageEventTerms = () => import(/* webpackChunkName: "manageeventterms" */ '@/components/modules/ticketsystem/manageevent/base-info/terms/ManageEventTerms');
const ManageEventTicketDesign = () => import(/* webpackChunkName: "manageeventticketdesign" */ '@/components/modules/ticketsystem/manageevent/base-info/ticket-design/ManageEventTicketDesign.vue');
const ManageEventPricing = () => import(/* webpackChunkName: "manageeventpricing" */ '@/components/modules/ticketsystem/manageevent/pricing/ManageEventPricing.vue');
const ManageEventVenue = () => import(/* webpackChunkName: "manageeventvenue" */ '@/components/modules/ticketsystem/manageevent/arena/ManageEventVenue.vue');
const ManageEventReview = () => import(/* webpackChunkName: "manageeventreview" */ '@/components/modules/ticketsystem/manageevent/review/ManageEventReview');
const ManageEventConfirmation = () => import(/* webpackChunkName: "manageeventconfirmation" */ '@/components/modules/ticketsystem/summary/confirmation/EventActivatedConfirmationView');
const CancelMoveEvent = () => import(/* webpackChunkName: "cancelmoveevent" */ '@/components/modules/ticketsystem/cancelmove/CancelEventModule.vue');
const VoucherListModule = () => import(/* webpackChunkName: "voucherlist" */ '@/components/modules/ticketsystem/sales/vouchers/VoucherListModule');
const RetailersModule = () => import(/* webpackChunkName: "retailers" */ '@/components/modules/ticketsystem/sales/retailers/RetailersModule.vue');
const ManageVouchers = () => import(/* webpackChunkName: "managevouchers" */ '@/components/modules/ticketsystem/sales/vouchers/ManageVouchers');
const PreReleaseAccessCodeModule = () => import(/* webpackChunkName: "prereleaseaccesscode" */'@/components/modules/ticketsystem/sales/campaign/pre-release/PreReleaseAccessCodeModule');

const manageEventChildren = (type) => [
  {
    component: ManageEventBaseInfo,
    path: 'event-info',
    redirect: 'event-info/:showIndex?',
    name: subModuleKeys.MANAGE_EVENT_BASE(type),
    props: {
      moduleKey: type,
    },
    children: [
      {
        path: 'branding',
        name: subModuleKeys.MANAGE_EVENT_BRANDING(type),
        component: ManageEventBranding,
        props: {
          moduleKey: subModuleKeys.MANAGE_EVENT_BRANDING(type),
        },
        meta: {
          baseName: type,
          disableRedirectShow: true,
        },
      },
      {
        path: 'sales-options',
        name: subModuleKeys.MANAGE_EVENT_SALES_OPTIONS(type),
        component: ManageEventPurchaseSettings,
        props: {
          moduleKey: subModuleKeys.MANAGE_EVENT_SALES_OPTIONS(type),
        },
        meta: {
          baseName: type,
          disableRedirectShow: true,
        },
      },
      {
        path: 'terms',
        name: subModuleKeys.MANAGE_EVENT_TERMS(type),
        component: ManageEventTerms,
        props: {
          moduleKey: subModuleKeys.MANAGE_EVENT_TERMS(type),
        },
        meta: {
          baseName: type,
          disableRedirectShow: true,
        },
      },
      {
        path: 'ticket-design',
        name: subModuleKeys.MANAGE_EVENT_TICKET_DESIGN(type),
        component: ManageEventTicketDesign,
        props: {
          moduleKey: subModuleKeys.MANAGE_EVENT_TICKET_DESIGN(type),
        },
        meta: {
          baseName: type,
          disableRedirectShow: true,
        },
      },
      {
        path: ':showIndex?',
        name: subModuleKeys.MANAGE_EVENT_BASIC_INFO(type),
        component: ManageEventBasicInfo,
        props: {
          moduleKey: subModuleKeys.MANAGE_EVENT_BASIC_INFO(type),
        },
        meta: {
          baseName: type,
        },
      },
    ],
  },
  {
    component: ManageEventVenue,
    name: subModuleKeys.MANAGE_EVENT_VENUE(type),
    path: 'venue/:showIndex?',
    props: {
      moduleKey: subModuleKeys.MANAGE_EVENT_VENUE(type),
    },
    meta: {
      hasShowSelector: true,
      baseName: type,
      fetchExtraInfo: true,
    },
  },
  {
    component: ManageEventPricing,
    name: subModuleKeys.MANAGE_EVENT_PRICING(type),
    path: 'pricing/:showIndex?',
    props: {
      moduleKey: subModuleKeys.MANAGE_EVENT_PRICING(type),
    },
    meta: {
      hasShowSelector: true,
      baseName: type,
      fetchExtraInfo: true,
    },
  },
  {
    component: ManageEventReview,
    name: subModuleKeys.MANAGE_EVENT_REVIEW(type),
    path: 'review',
    props: {
      moduleKey: subModuleKeys.MANAGE_EVENT_REVIEW(type),
    },
    meta: {
      hasShowSelector: false,
      baseName: type,
      disableRedirectShow: true,
    },
  },
];

const subModules = {
  [subModuleKeys.LIST_EVENT]: {
    name: subModuleKeys.LIST_EVENT,
    component: ListEventsModule,
    path: '/events/list',
    props: { moduleKey: subModuleKeys.LIST_EVENT },
  },
  [subModuleKeys.CREATE_EVENT]: {
    component: ManageEvent,
    name: subModuleKeys.CREATE_EVENT,
    path: '/events/new',
    redirect: '/events/new/event-info',
    props: {
      moduleKey: subModuleKeys.CREATE_EVENT,
    },
    meta: {
      baseName: subModuleKeys.CREATE_EVENT,
    },
    children: manageEventChildren(subModuleKeys.CREATE_EVENT),
  },
  [subModuleKeys.MANAGE_EVENT]: {
    component: ManageEvent,
    name: subModuleKeys.MANAGE_EVENT,
    path: '/events/:eventId?/edit',
    redirect: '/events/:eventId?/edit/event-info',
    props: {
      moduleKey: subModuleKeys.MANAGE_EVENT,
    },
    meta: {
      baseName: subModuleKeys.MANAGE_EVENT,
    },
    children: [
      ...manageEventChildren(subModuleKeys.MANAGE_EVENT),
      {
        component: ManageEventConfirmation,
        name: subModuleKeys.MANAGE_EVENT_CONFIRM,
        path: 'confirm',
        props: (route) => ({
          moduleKey: subModuleKeys.MANAGE_EVENT_CONFIRM,
          eventId: route
            ? parseInt(route.params.eventId, 10)
            : null,
          eventStatus: route
            ? parseInt(route.query.eventStatus, 10)
            : null,
        }),
        meta: {
          baseName: subModuleKeys.MANAGE_EVENT,
        },
      },
    ],
  },
  [subModuleKeys.CAMPAIGN_TOOL]: {
    name: subModuleKeys.CAMPAIGN_TOOL,
    component: SalesStatisticsModule,
    path: '/events/campaign',
    props: { moduleKey: subModuleKeys.CAMPAIGN_TOOL },
    tags: [
      'Rabatt',
    ],
  },
  [subModuleKeys.SALES_LINKS]: {
    name: subModuleKeys.SALES_LINKS,
    component: SalesLinksModule,
    path: '/events/salesLinks/:eventId?/:showId?',
    overriddenMenuPath: '/events/salesLinks/',
    meta: {
      noTransition: true,
      applyEventUnderEdit: true,
    },
    props: (route) => (
      {
        moduleKey: subModuleKeys.SALES_LINKS,
        eventId: route
          ? parseInt(route.params.eventId, 10)
          : null,
      }),
  },
  [subModuleKeys.ARENA_SEATING]: {
    name: subModuleKeys.ARENA_SEATING,
    component: ArenaSeatingModule,
    path: '/events/seating/:eventId?/:showId?',
    meta: {
      noTransition: true,
      applyEventUnderEdit: true,
      applyShowUnderEdit: true,
    },
    props: (route) => (
      {
        moduleKey: subModuleKeys.ARENA_SEATING,
        eventId: route
          ? parseInt(route.params.eventId, 10)
          : null,
        showId: route
          ? parseInt(route.params.showId, 10)
          : null,
      }),
  },
  [subModuleKeys.COMBO_SALES]: {
    name: subModuleKeys.COMBO_SALES,
    component: ComboSalesModule,
    path: '/events/combosales',
    props: { moduleKey: subModuleKeys.COMBO_SALES },
  },
  [subModuleKeys.MERCHANDISE]: {
    component: MerchandiseModule,
    path: '/merchandise',
    props: { moduleKey: subModuleKeys.MERCHANDISE },
    children: [
      {
        path: '',
        props: { moduleKey: subModuleKeys.MERCHANDISE },
        component: MerchandiseMainMenu,
        children: [
          {
            name: subModuleKeys.MERCHANDISE,
            path: '',
            props: { moduleKey: subModuleKeys.MERCHANDISE },
            component: MerchandiseList,
          },
          {
            name: 'MerchandiseConnectionsList',
            path: 'connections/list/:eventId?/:showId?',
            props: (route) => ({
              eventId: Number.parseInt(route.params.eventId, 10) || null,
              showId: Number.parseInt(route.params.showId, 10) || null,
              moduleKey: subModuleKeys.MERCHANDISE,
            }),
            component: MerchandiseConnections,
          },
        ],
      },
      {
        name: 'EditMerchandise',
        path: 'edit/:id',
        props: (route) => ({ id: Number.parseInt(route.params.id, 10), moduleKey: subModuleKeys.MERCHANDISE }),
        component: MerchandiseEdit,
      },
      {
        name: 'CopyMerchandise',
        path: 'copy/:id',
        component: MerchandiseEdit,
        props: (route) => ({
          id: Number.parseInt(route.params.id, 10),
          isCopy: true,
          moduleKey: subModuleKeys.MERCHANDISE,
        }),
      },
      {
        name: 'CreateMerchandise',
        path: 'create',
        props: { moduleKey: subModuleKeys.MERCHANDISE },
        component: MerchandiseEdit,
      },
      {
        name: 'MerchandiseConnections',
        path: 'connections',
        redirect: 'connections/list',
      },
      {
        name: 'MerchandiseConnectionsEdit',
        path: 'connections/edit/:merchId?',
        component: MerchandiseConnectionsEdit,
        props: (route) => (
          {
            moduleKey: subModuleKeys.ARENA_SEATING,
            merchId: route
              ? parseInt(route.params.merchId, 10)
              : null,
            scrollToShowMerchId: route.params.scrollToShowMerchId,
          }),
      },
    ],
  },
  [subModuleKeys.RETAILER]: {
    component: RetailersModule,
    name: subModuleKeys.RETAILER,
    path: '/retailers/:eventId?/:showId?',
    props: (route) => ({
      moduleKey: subModuleKeys.RETAILER,
      eventId: route
        ? parseInt(route.params.eventId, 10) || null
        : null,
      showId: route
        ? parseInt(route.params.showId, 10) || null
        : null,
    }),
  },
  [subModuleKeys.CANCEL_EVENT]: {
    name: subModuleKeys.CANCEL_EVENT,
    component: CancelMoveEvent,
    path: '/events/cancel',
    props: {
      moduleKey: subModuleKeys.CANCEL_EVENT,
    },
  },
  [subModuleKeys.VOUCHERS]: {
    name: subModuleKeys.VOUCHERS,
    component: VoucherListModule,
    path: '/advanced-salessettings/vouchers',
    props: {
      moduleKey: subModuleKeys.VOUCHERS,
    },
  },
  ManageVouchers: {
    name: 'ManageVouchers',
    component: ManageVouchers,
    path: '/advanced-salessettings/vouchers/manage/:voucherId?',
    props: {
      moduleKey: subModuleKeys.VOUCHERS,
    },
  },
  [subModuleKeys.PRE_RELEASE_ACCESS_CODE]: {
    name: subModuleKeys.PRE_RELEASE_ACCESS_CODE,
    component: PreReleaseAccessCodeModule,
    path: '/campaign/prerelease/:eventId?/:showId?',
    props: (route) => ({
      moduleKey: subModuleKeys.PRE_RELEASE_ACCESS_CODE,
      eventId: route
        ? parseInt(route.params.eventId, 10)
        : null,
      showId: route
        ? parseInt(route.params.showId, 10)
        : null,
    }),
  },
};

export default subModules;
